import { html, LitElement } from 'lit-element';

/**
 * @element question-modal-multiple-choice
 * @prop {Object} model - Response
 */
export class QuestionModalMultipleChoice extends LitElement {
  static get properties() {
    return {
      model: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { choices, keyMode } = this.model || {};

    if (!choices) return '';

    const charCode = keyMode === 'numbers' ? 49 : 65;

    return html`<div>
      <div class="question-modal modal-response-content">
        ${choices.map((choice, index) => {
          const { correct, label, rationale } = choices[index] || {};
          const correctnessClass = correct ? 'correct' : 'unanswered';

          return html` <div class="question-modal modal-response-content-row">
            <div
              class="question-modal header-correct-response-selection ${correctnessClass}"
            >
              ${String.fromCharCode(index + charCode)}
            </div>
            <div class="question-modal response-value" style="margin-right: 0">
              <math-rendering-element .label=${label}></math-rendering-element>

              <div
                class="question-modal response-value"
                style="margin: 8px 0 0 8px;"
              >
                <math-rendering-element
                  .label=${rationale}
                ></math-rendering-element>
              </div>
            </div>
          </div>`;
        })}
      </div>
    </div>`;
  }
}

export default QuestionModalMultipleChoice;
